// Тексты подсказок к показателям. Лежат отдельно, потому что одни и те же метрики
// показываются и на главной, и в раскрытой подробной статистике — формулировки должны совпадать.
export const MY_MONEY_TOOLTIPS = {
  available: 'Разность «Баланс» и «Зарезервировано»',
  reserved:
    'Сумма средств, зарезервированных в проектах, по которым еще не было оплаты по Договору',

  depositTotal: 'Сумма ваших пополнений',
  investedTotal:
    'Сумма ваших инвестиций с вознаграждением за инвестиции по проектам, в которых была оплата по Договору',
  comebackTotal:
    'Сумма взысканий на вашу долю за вычетом вознаграждений за доход и инкассо платежей кредитору',
  withdrawTotal: 'Сумма средств, выведенных на ваш банковский счет',

  currentInvested: 'Сумма ваших инвестиций с вознаграждением за инвестиции в текущих проектах',
  currentIncomeLeft:
    'Сумма прогнозов будущих взысканий на вашу долю за вычетом вознаграждений за доход по текущим проектам',
  currentIncomePaid:
    'Сумма взысканий на вашу долю за вычетом вознаграждений за доход и инкассо платежей кредитору по текущим проектам',
  currentForecastROI: 'Средневзвешенный прогноз простой доходности ROI по текущим проектам',
  currentForecastYearROI: 'Средневзвешенный прогноз годовой доходности ROI по текущим проектам',
  currentForecastIRR: 'Средневзвешенный прогноз годовой доходности IRR по текущим проектам',
  currentTerm: 'Средневзвешенный плановый срок по текущим проектам',

  closedInvested: 'Сумма ваших инвестиций и вознаграждений за инвестиции в завершенных проектах',
  closedComeback:
    'Сумма взысканий на вашу долю за вычетом вознаграждений за доход и инкассо платежей кредитору в завершенных проектах',
  closedNetProfit: 'Разность «Возвращено» и «Инвестировано»',
  closedFactROI:
    'Средневзвешенная фактическая простая доходность ROI по завершенным проектам (включая дефолты)',
  closedFactYearROI:
    'Средневзвешенная фактическая годовая доходность ROI по завершенным проектам (включая дефолты)',
  closedFactIRR:
    'Средневзвешенная фактическая годовая доходность IRR по завершенным проектам (включая дефолты)',
  closedTerm: 'Средневзвешенный фактический срок завершенных проектов',
} as const;
